// extracted by mini-css-extract-plugin
export default {"ShareBody":"shareModal_ShareBody__F9-mA","ShareBox":"shareModal_ShareBox__+T8gM","ShareTips":"shareModal_ShareTips__EC4-S"};